import type { Ref } from 'vue'
import type { ProductHistoryInput, ProductHistoryItem } from '~/utils/historyRecommendations'
import { useStorage } from '@vueuse/core'
import { normalizeProductHistory, recordProductHistory } from '~/utils/historyRecommendations'

export default defineNuxtPlugin({
  name: 'product-history',
  setup(nuxtApp) {
    const locale = (nuxtApp.$i18n as any).locale as Ref<string>
    const history = useStorage<ProductHistoryItem[]>(() => `product-history:${locale.value}`, [])

    const checkProductFreshness = () => {
      history.value = normalizeProductHistory(history.value)
    }

    watch(locale, checkProductFreshness, { immediate: true, flush: 'post' })

    const addItemToHistory = (item: ProductHistoryInput) => {
      history.value = recordProductHistory(history.value, item)
    }

    const clearProductHistory = () => {
      history.value = []
    }

    return {
      provide: {
        history: {
          history,
          addItemToHistory,
          clearProductHistory,
        },
      },
    }
  },
})

interface HistoryPlugin {
  history: Ref<ProductHistoryItem[]>
  addItemToHistory: (item: ProductHistoryInput) => void
  clearProductHistory: () => void
}

declare module '#app' {
  interface NuxtApp {
    $history: HistoryPlugin
  }
}

declare module 'vue' {
  interface ComponentCustomProperties {
    $history: HistoryPlugin
  }
}
